module.exports = __webpack_public_path__ + "media/site_templates/www.tapreplacement.com.au/images/our_services_3-a9473aaf077b9fa94b0314a934d543e1.jpg";